import React from 'react';
import { connect } from 'react-redux';

import RGBVideo from './components/RGBVideo/RGBVideo';
import {
  setThermalStreamSettings,
  setRGBStreamSettings,
  setRGBFaceDetectionSettings,
  setThermalFaceDetectionSettings,
  setMaskDetectionSettings,
  startThermalProcess,
  clearThermalSolutionBox,
  setBackend,
} from './store/actions';

import './App.css';

interface AppProps {
  setRGBStreamSettings: any;
  setThermalStreamSettings: any;
  setThermalFaceDetectionSettings: any;
  setMaskDetectionSettings: any;
  setRGBFaceDetectionSettings: any;
  setBackend: any;
  rgbStreamSettings: any;
  thermalStreamSettings: any;
  rgbFaceDetectionSettings: any;
  thermalFaceDetectionSettings: any;
  maskDetectionsSettings: any;
  backend: string;
  isStartThermalProcess: boolean;
  isClearThermalSolutionBox: boolean;
  startThermalProcess: any;
  clearThermalSolutionBox: any;
}

interface AppState {
  isLoaded: boolean;
}

class App extends React.Component<AppProps, AppState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isLoaded: false,
    };
  }

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);

    // RGB params
    if (query.get('rgbVideoDeviceTrack')) {
      // eslint-disable-next-line
      // @ts-ignore
      this.props.setRGBStreamSettings('videoDeviceTrack', +query.get('rgbVideoDeviceTrack'));
    }

    if (query.get('rgbVideoDeviceIndex')) {
      // eslint-disable-next-line
      // @ts-ignore
      this.props.setRGBStreamSettings('videoDeviceIndex', +query.get('rgbVideoDeviceIndex'));
    }

    if (query.get('rgbBoundingBoxShow')) {
      this.props.setRGBStreamSettings('boundingBoxShow', query.get('rgbBoundingBoxShow') === 'true');
    }

    if (query.get('rgbFaceScoreThreshold')) {
      // eslint-disable-next-line
      // @ts-ignore
      this.props.setRGBFaceDetectionSettings('scoreThreshold', +query.get('rgbFaceScoreThreshold'));
    }

    if (query.get('solutionBoxSize')) {
      // eslint-disable-next-line
      // @ts-ignore
      this.props.setRGBFaceDetectionSettings('solutionBoxSize', +query.get('solutionBoxSize'));
      // eslint-disable-next-line
      // @ts-ignore
      this.props.setThermalFaceDetectionSettings('solutionBoxSize', +query.get('solutionBoxSize'));
    }

    // Thermal params
    if (query.get('thermalSolutionBoxSize')) {
      // eslint-disable-next-line
      // @ts-ignore
      this.props.setThermalStreamSettings('solutionBoxSize', +query.get('thermalSolutionBoxSize'));
    }

    if (query.get('thermalVideoDeviceTrack')) {
      // eslint-disable-next-line
      // @ts-ignore
      this.props.setThermalStreamSettings('videoDeviceTrack', +query.get('thermalVideoDeviceTrack'));
    }

    if (query.get('thermalVideoDeviceIndex')) {
      // eslint-disable-next-line
      // @ts-ignore
      this.props.setThermalStreamSettings('videoDeviceIndex', +query.get('thermalVideoDeviceIndex'));
    }

    if (query.get('thermalMode')) {
      this.props.setThermalStreamSettings('mode', query.get('thermalMode'));
    }

    if (query.get('thermalBoundingBoxShow')) {
      this.props.setThermalStreamSettings('boundingBoxShow', query.get('thermalBoundingBoxShow') === 'true');
    }

    if (query.get('thermalDataReadFormat')) {
      this.props.setThermalStreamSettings('thermalDataReadFormat', query.get('thermalDataReadFormat'));
    }

    if (query.get('thermalFaceScoreThreshold')) {
      // eslint-disable-next-line
      // @ts-ignore
      this.props.setThermalFaceDetectionSettings('scoreThreshold', +query.get('thermalFaceScoreThreshold'));
    }

    // Mask detection params
    if (query.get('mobileNetVersion')) {
      this.props.setMaskDetectionSettings('mobileNetVersion', query.get('mobileNetVersion'));
    }

    if (query.get('mobileNetWeight')) {
      this.props.setMaskDetectionSettings('mobileNetWeight', query.get('mobileNetWeight'));
    }

    if (query.get('mobileNetType')) {
      this.props.setMaskDetectionSettings('mobileNetType', query.get('mobileNetType'));
    }

    if (query.get('thumbnailSizeForMask')) {
      this.props.setMaskDetectionSettings('thumbnailSizeForMask', query.get('thumbnailSizeForMask'));
    }

    if (query.get('setBackend')) {
      this.props.setBackend(query.get('setBackend'));
    }

    this.setState({
      isLoaded: true,
    });
  }

  render() {
    const {
      rgbStreamSettings,
      thermalStreamSettings,
      backend,
      maskDetectionsSettings,
      rgbFaceDetectionSettings,
      thermalFaceDetectionSettings,
      isStartThermalProcess,
      isClearThermalSolutionBox,
      startThermalProcess,
      clearThermalSolutionBox,
    } = this.props;

    const { isLoaded } = this.state;

    return (
      <div className="App-header">
        {isLoaded && (
          <>
            <RGBVideo
              width={rgbStreamSettings.videoWidth}
              height={rgbStreamSettings.videoHeight}
              videoDeviceIndex={rgbStreamSettings.videoDeviceIndex}
              videoDeviceTrack={rgbStreamSettings.videoDeviceTrack}
              boundingBoxShow={rgbStreamSettings.boundingBoxShow}
              backend={backend}
              maskDetectionsSettings={maskDetectionsSettings}
              faceDetectionSettings={rgbFaceDetectionSettings}
              startThermalProcess={startThermalProcess}
              clearThermalSolutionBox={clearThermalSolutionBox}
              isStartThermalProcess={isStartThermalProcess}
              isClearThermalSolutionBox={isClearThermalSolutionBox}
            />
          </>
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    // eslint-disable-next-line
    // @ts-ignore
    backend: state.system.backend,
    // eslint-disable-next-line
    // @ts-ignore
    rgbStreamSettings: state.system.rgbStreamSettings,
    // eslint-disable-next-line
    // @ts-ignore
    thermalStreamSettings: state.system.thermalStreamSettings,
    // eslint-disable-next-line
    // @ts-ignore
    maskDetectionsSettings: state.system.maskDetectionsSettings,
    // eslint-disable-next-line
    // @ts-ignore
    rgbFaceDetectionSettings: state.system.rgbFaceDetectionSettings,
    // eslint-disable-next-line
    // @ts-ignore
    thermalFaceDetectionSettings: state.system.thermalFaceDetectionSettings,
    // eslint-disable-next-line
    // @ts-ignore
    isStartThermalProcess: state.system.isStartThermalProcess,
    // eslint-disable-next-line
    // @ts-ignore
    isClearThermalSolutionBox: state.system.isClearThermalSolutionBox,
  }),
  {
    setBackend,
    setRGBFaceDetectionSettings,
    setThermalFaceDetectionSettings,
    setThermalStreamSettings,
    setRGBStreamSettings,
    setMaskDetectionSettings,
    startThermalProcess,
    clearThermalSolutionBox,
  },
)(App);
